import React from 'react';
import { Button, Popup } from 'semantic-ui-react';
import PayBonusModal from '../../../../Transactions/PayBonusModal';

const PayBonusButton = ({ job, size }) => {
  if (job.expert.stripeAccount.isConnected) {
    return (
      <PayBonusModal job={job}>
        <Button size={size} basic color="black">
          Pay Bonus
        </Button>
      </PayBonusModal>
    );
  }
  return (
    <Popup
      disabled={job.expert.stripeAccount.isConnected}
      content="Bonus is only available to Stripe-connected experts"
      trigger={(
        <Button
          size={size}
          basic
          color="black"
          className="disabled-btn"
        >
          Pay Bonus
        </Button>
      )}
    />
  );
};

export default PayBonusButton;
